<template>
  <div class="app-bar-layout">

    <template v-if="$forSize['desktop-up']">
      <t-bar>

        <template v-slot:start>
          <a class="logo-anchor" @click="$router.push('/')">
            <img class="logo" :src="$config.images['logo']" v-bind:title="sysVersion" alt="Logo" />
          </a>
        </template>

        <template v-slot:middle>
          <div class="full-height">
            <routes color="var(--on-header)" highlightColor="transparent"/>
          </div>
        </template>

        <template v-slot:end>
          <div v-if="$config.featureFlags['EXIBIR_BOTAO_ENTRAR']" class="hedar-last-section">
            <span v-html="$config.strings['header-btn-6']" />
            <t-button
              backgroundColor="var(--primary)"
              color="var(--on-primary)"
              size="lg"
              raised
              @click="loginRedirect"
              v-html="$config.strings['header-btn-7']"
            >
            </t-button>
          </div>
        </template>

      </t-bar>
    </template>

    <template v-else>
      <t-bar>

        <template v-slot:start>
          <btn-menu />
        </template>

        <template v-slot:middle>
          <a class="logo-anchor" @click="$router.push('/')">
            <img class="logo" :src="$config.images['logo']" />
          </a>
        </template>

        <template v-slot:end>
          <login-menu v-if="$config.featureFlags['EXIBIR_BOTAO_ENTRAR']" />
        </template>

      </t-bar>
    </template>

    <transition name="fade" :duration="150" mode="out-in">
      <router-view :class="contentClass" />
    </transition>

    <t-footer v-if="!noFooter" />

  </div>
</template>

<script>
import { TBar, TButton, TFooter } from '@/components/base'
import BtnMenu from '@/components/common/MenuButton'
import Routes from '@/components/common/Routes'
import LoginMenu from '@/components/common/LoginMenu'
import WaitImagesLoad from '@/mixins/wait-images-load'

export default {
  name: 'app-bar-layout',
  components: { TBar, TButton, TFooter, BtnMenu, Routes, LoginMenu },
  mixins: [WaitImagesLoad],
  computed: {
    images () {
      return {
        APPBAR_LOGO: this.$config.images['logo']
      }
    },
    noFooter () {
      return (this.$route.path === '/regulamento' || this.$route.path === '/cadastrar')
    },
    contentClass () {
      const c = []
      c.push('content')
      this.noFooter && c.push('no-footer')
      return c.join(' ')
    },
    sysVersion () { return `Versão: ${VERSION}` }
  },
  methods: {
    loginRedirect () {
      location.href = this.$config.urls.login_url
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-primeiro-acesso-title {
  width: 100%;
  text-align: center;
  margin-top: 30px;
  cursor: pointer;

  a {
    color: var(--on-primary);
    text-align: center;
    margin: 15px 0;
    width: 100%;
    font-size: 14px;
    text-decoration: underline;
  }
}

.primeiro-acesso-title {
  color: var(--on-primary);
  text-align: center;
  margin: 15px 0;
  width: 100%;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
}

.nav-btn-login {
  width: 176px;
  background-color: var(--secondary);
  color: var(--on-secondary);
}

.full-height {
  display: flex;
  height: 100%;
}

.app-bar-layout {
  > .content {
    background-color: var(--background);
    color: var(--on-background);
    $app-bar-height: 103px;
    $footer-height: 92px;
    min-height: calc((100vh - #{$app-bar-height}) - #{$footer-height});

    &.no-footer {
      $footer-height: 0px;
      min-height: calc((100vh - #{$app-bar-height}) - #{$footer-height});
    }

    @include for-size(phone-only) {
      $app-bar-height: 72px;
      $footer-height: 0px;
      min-height: calc((100vh - #{$app-bar-height}) - #{$footer-height});
    }
  }

  .logo-anchor {
    display: block;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: 103px;
    .logo {
      padding: 13px;
      max-width: 120px;
      width: 100%;
      height: 100%;

      @include for-size(desktop-up) {
        max-width: 150px;
      }
    }
  }

  .hedar-last-section {
    display: flex;
    flex-flow: column nowrap;
    color: var(--on-header);
    padding: 10px 0 10px 25px;
  }
}
</style>
